import { stages } from 'Constants/stages';
import { FilingInfo, invoiceFlexResponse, RecordFilingInfo } from 'Types/common';

const IS_FLEX = 'isFlex';
const IS_FINISHED = 'isFinished';
const IS_VALIDATION = 'isValidation';
const NOT_FILED = 'notFiled';

export const getContext = (
  isFlex: boolean,
  userStage: string | null,
  lastPresentation?: RecordFilingInfo,
  isUserWithPreFiling?: boolean
): string => {
  if (isUserWithPreFiling) return NOT_FILED;
  if (userStage === stages.FINISHED_SUCCESS) return IS_FINISHED;
  if (userStage === stages.VALIDATION) return IS_VALIDATION;
  if (isFlex) return IS_FLEX;
  if (lastPresentation?.status) return lastPresentation.status;
  return '';
};

export const calculatePartialPrice = (
  flexInfo?: invoiceFlexResponse,
  filingInfo?: FilingInfo
): number => {
  if (flexInfo) {
    const flexPrice = Math.round(flexInfo.amountDue);
    return Math.round(flexInfo.baseServiceAmount) - flexPrice;
  }

  return filingInfo?.recent?.taxAgencyResolvedAmount || 0;
};

export const calculateFinalAmountForValidation = (recentAmount = 0, feeValue = 0): number =>
  Math.abs(recentAmount) - feeValue;

export const calculateBaseAmount = (
  baseServiceAmount?: number,
  amount?: number,
  taxReturnResult?: number | string
): number => {
  return Math.abs(baseServiceAmount || amount || Number(taxReturnResult));
};

export const calculateFlexDiscount = (isFlex: boolean, amountDue?: number): number => {
  return isFlex && amountDue ? amountDue : 0;
};

export const calculateFinalAmount = (baseAmount: number, flexDiscount: number): number =>
  baseAmount - flexDiscount;

export const convertToCurrency = (amount?: number): number => {
  return amount ? amount / 100 : 0;
};
